module.exports = __webpack_public_path__ + "img/CommunalFacility.0d31ad7f.svg";